import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Toggle from '../../ui/Toggle';
import DatePicker from '../../ui/DatePicker';
import { selectRewardForm, updateRewardForm } from '../../../store/slices/gamificationSlice';

const TimeBoundSection = () => {
  const dispatch = useDispatch();
  const rewardForm = useSelector(selectRewardForm);

  return (
    <div className="space-y-3">
      <Toggle
        checked={rewardForm.isTimeBound}
        onChange={(value) => {
          dispatch(updateRewardForm({ field: 'isTimeBound', value }));
          if (!value) {
            dispatch(updateRewardForm({ field: 'endDate', value: null }));
          }
        }}
        label="Make the reward time bound"
        helperText="Choose an end date to stop this reward automatically."
      />

      {rewardForm.isTimeBound && (
        <DatePicker
          value={rewardForm.endDate}
          onChange={(value) =>
            dispatch(updateRewardForm({ field: 'endDate', value }))
          }
          placeholder="Select End Date"
          side="top"
        />
      )}
    </div>
  );
};

export default TimeBoundSection;
